/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ViennaAddressImportStatusResponse
 */
export interface ViennaAddressImportStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ViennaAddressImportStatusResponse
     */
    isImporting: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ViennaAddressImportStatusResponse
     */
    lastImportedAt: Date | null;
}

/**
 * Check if a given object implements the ViennaAddressImportStatusResponse interface.
 */
export function instanceOfViennaAddressImportStatusResponse(value: object): value is ViennaAddressImportStatusResponse {
    if (!('isImporting' in value) || value['isImporting'] === undefined) return false;
    if (!('lastImportedAt' in value) || value['lastImportedAt'] === undefined) return false;
    return true;
}

export function ViennaAddressImportStatusResponseFromJSON(json: any): ViennaAddressImportStatusResponse {
    return ViennaAddressImportStatusResponseFromJSONTyped(json, false);
}

export function ViennaAddressImportStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViennaAddressImportStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isImporting': json['isImporting'],
        'lastImportedAt': (json['lastImportedAt'] == null ? null : new Date(json['lastImportedAt'])),
    };
}

export function ViennaAddressImportStatusResponseToJSON(json: any): ViennaAddressImportStatusResponse {
    return ViennaAddressImportStatusResponseToJSONTyped(json, false);
}

export function ViennaAddressImportStatusResponseToJSONTyped(value?: ViennaAddressImportStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isImporting': value['isImporting'],
        'lastImportedAt': value['lastImportedAt'] == null ? value['lastImportedAt'] : value['lastImportedAt'].toISOString(),
    };
}

